import { render, staticRenderFns } from "./Titlebar.vue?vue&type=template&id=57e20002&"
import script from "./Titlebar.vue?vue&type=script&lang=ts&"
export * from "./Titlebar.vue?vue&type=script&lang=ts&"
import style0 from "./Titlebar.vue?vue&type=style&index=0&id=57e20002&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports